import React from 'react'
import styled from 'react-emotion'
import { cx } from 'emotion'
import { themeGet as th } from 'styled-system'
import themeVars from 'ui_theme/site/globals/site.variables'
import ReplyForm from 'components/App/DesktopView/ReplyForm'
import NavBar from 'components/App/DesktopView/shared/Composer/Email/Header/NavBar'
import { Flex, Box } from 'shared/ui'
import withFocusing from './withFocusing'

const Replying = ({
  className,
  focused, // from withFocusing
  isForwarding,
  isOpen,
  onClick,
  onEditorBlur,
  onEditorFocus,
  ticketId,
}) => {
  return (
    <Flex
      className={cx(className, { forwarding: isForwarding, focused })}
      flexDirection="column"
      onClick={onClick}
    >
      <NavBar replying ticketId={ticketId} />
      <Box css={{ marginTop: themeVars.small }}>
        <ReplyForm
          isOpen={isOpen}
          onEditorBlur={onEditorBlur}
          onEditorFocus={onEditorFocus}
          subjectPrefix={'Re:'}
          ticketId={ticketId}
        />
      </Box>
    </Flex>
  )
}

export default styled(withFocusing(Replying))`
  background-color: ${th('colors.white')};
  border-radius: 4px;
  border: 1px solid ${th('colors.dust')};
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.05);
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  padding: ${th('space.2')}px ${th('space.3')}px;
  opacity: 1;
  visibility: visible;
  z-index: 100;

  &.forwarding {
    background-color: ${th('colors.forward')};
  }

  &.focused {
    border-color: ${th('colors.groovy')};
  }
`
